var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Preloader'),_c('Canvas'),_c('Controls'),_c('AmbientSound'),_c('Tooltip'),_c('SVGSprite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }